export default __webpack_public_path__ + "static/media/nav-circle-ok.795d0ba6.svg";